const articlesContainers = document.querySelectorAll('.related-articles__cards');

articlesContainers.forEach((container) => {
  initializeRelatedArticles(container)
});

function initializeRelatedArticles(container) {
  const articles = container.querySelectorAll('.generic-card');

  articles.forEach((article) => article.classList.add('swiper-slide'));

  if (articles.length === 2 || articles.length === 5) {
    articles[0].classList.add('related-articles__card--large');
    articles[1].classList.add('related-articles__card--large');
  } else if (articles.length === 4) {
    articles.forEach((article) => article.classList.add('related-articles__card--large'));
  }
}

export { initializeRelatedArticles };